































import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 营销数据
      marketingData = computed(() => this.goodsData.value.marketingData)
    },
)
